module.exports = __webpack_public_path__ + "img/settings.fc3d725e.svg";